(() => {
  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-lm-product]').forEach(root => {
      if (root.dataset.lmReady) return;
      root.dataset.lmReady = 'true';
      const select = root.querySelector('[data-lm-variant]');
      const price = root.querySelector('[data-lm-price]');
      const add = root.querySelector('[data-lm-add]');
      const quantity = root.querySelector('input[name="quantity"]');
      const setImage = (src, alt) => {
        const frame = root.querySelector('[data-lm-main-image]');
        if (!src || !frame) return;
        let image = frame.querySelector('img');
        if (!image) { frame.replaceChildren(); image = document.createElement('img'); image.className = 'lm-image'; frame.append(image); }
        image.removeAttribute('srcset'); image.removeAttribute('sizes'); image.src = src; image.alt = alt || '';
      };
      const update = () => {
        const option = select.selectedOptions[0];
        if (!option) return;
        price.replaceChildren(document.createTextNode(option.dataset.price));
        if (option.dataset.compare) { const old = document.createElement('s'); old.textContent = option.dataset.compare; price.append(old); }
        const available = option.dataset.available === 'true';
        add.disabled = !available; add.textContent = available ? add.dataset.addLabel : add.dataset.soldLabel;
        quantity.min = option.dataset.min || '1'; quantity.step = option.dataset.increment || '1';
        if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
        quantity.value = quantity.min;
        if (option.dataset.image) setImage(option.dataset.image, option.dataset.alt);
        const url = new URL(window.location.href); url.searchParams.set('variant', option.value); window.history.replaceState({}, '', url);
      };
      select?.addEventListener('change', update);
      root.querySelectorAll('[data-lm-image]').forEach(button => button.addEventListener('click', () => {
        setImage(button.dataset.lmImage, button.dataset.lmAlt);
        root.querySelectorAll('[data-lm-image]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      }));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise()); else initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
